import { useMemo } from "react";
import { FilterTypes } from "../types";

export const useFilterFixtures = (serverFixtures: any[], currentFilter: any) => {
  return useMemo(() => {
    let data = serverFixtures || [];

    Object.keys(currentFilter).forEach((filterKey: string) => {
      if (!currentFilter[filterKey].length) {
        return;
      }

      const filterType = FilterTypes[filterKey as keyof typeof FilterTypes];

      if (filterType === FilterTypes.HomeCompetitors) {
        data = data.filter(
          (fixture: any) =>
            fixture.competitors.some(
              (competitor: any) => competitor.isHome === true && currentFilter[filterKey].includes(competitor.entityId),
            ) ||
            (currentFilter[filterKey].includes("") && !fixture.competitors.some((competitor: any) => competitor.isHome === true)),
        );
      }

      if (filterType === FilterTypes.AwayCompetitors) {
        data = data.filter(
          (fixture: any) =>
            fixture.competitors.some(
              (competitor: any) => competitor.isHome === false && currentFilter[filterKey].includes(competitor.entityId),
            ) ||
            (currentFilter[filterKey].includes("") && !fixture.competitors.some((competitor: any) => competitor.isHome === false)),
        );
      }

      if (filterType === FilterTypes.HomeParticipants) {
        data = data.filter(
          (fixture: any) =>
            fixture.participants.some(
              (participant: any) => participant.isHome === true && currentFilter[filterKey].includes(participant.personId),
            ) ||
            (currentFilter[filterKey].includes("") && !fixture.participants.some((participant: any) => participant.isHome === true)),
        );
      }

      if (filterType === FilterTypes.AwayParticipants) {
        data = data.filter(
          (fixture: any) =>
            fixture.participants.some(
              (participant: any) => participant.isHome === false && currentFilter[filterKey].includes(participant.personId),
            ) ||
            (currentFilter[filterKey].includes("") && !fixture.participants.some((participant: any) => participant.isHome === false)),
        );
      }

      if (filterType === FilterTypes.Venues) {
        data = data.filter((fixture: any) => currentFilter[filterKey].includes(fixture.venueId ?? ""));
      }

      if (filterType === FilterTypes.StartDates) {
        data = data.filter((fixture: any) => currentFilter[filterKey].includes(fixture.startTimeLocal?.split("T")[0] ?? ""));
      }

      if (filterType === FilterTypes.FixtureTypes) {
        data = data.filter((fixture: any) => currentFilter[filterKey].includes(fixture.fixtureType ?? ""));
      }

      if (filterType === FilterTypes.FixtureStatuses) {
        data = data.filter((fixture: any) => currentFilter[filterKey].includes(fixture.status ?? ""));
      }

      if (filterType === FilterTypes.Stages) {
        data = data.filter((fixture: any) => currentFilter[filterKey].includes(fixture.stageCode ?? ""));
      }

      if (filterType === FilterTypes.Pools) {
        data = data.filter((fixture: any) => currentFilter[filterKey].includes(fixture.poolCode ?? ""));
      }

      if (filterType === FilterTypes.Series) {
        data = data.filter((fixture: any) => currentFilter[filterKey].includes(fixture.seriesCode ?? ""));
      }
    });

    return data;
  }, [serverFixtures, currentFilter]);
};
